export function removeUpdateQueryParam() {
  const router = useRouter()
  const route = useRoute()

  const queryParams = { ...route.query }
  delete queryParams.update
  router.replace({ query: queryParams })
}
